module.exports = __webpack_public_path__ + "img/expense-history.0f09bd64.png";